import { $Color, $tag, TaggedEnumUnion, tagEnum } from '@suntex.core/types';

import { buildStaticContext } from '../utils';

const $ = 'GradeLevel';

export const GradeLevel = {
  LevelK: tagEnum($, 0),
  Level1: tagEnum($, 1),
  Level2: tagEnum($, 2),
  Level3: tagEnum($, 3),
  Level4: tagEnum($, 4),
  Level5: tagEnum($, 5),
  Level6: tagEnum($, 6),
  Level7: tagEnum($, 7),
  Level8: tagEnum($, 8),
} as const;

export type GradeLevel = TaggedEnumUnion<typeof GradeLevel>;

export const $GradeLevel = buildStaticContext({
  [$tag]: $,
  [GradeLevel.LevelK]: {
    value: GradeLevel.LevelK,
    symbol: 'K',
    slug: 'level-k',
    label: 'Level K',
    color: $Color.from('#9933ff'),
  },
  [GradeLevel.Level1]: {
    value: GradeLevel.Level1,
    symbol: '1',
    slug: 'level-1',
    label: 'Level 1',
    color: $Color.from('#cc33aa'),
  },
  [GradeLevel.Level2]: {
    value: GradeLevel.Level2,
    symbol: '2',
    slug: 'level-2',
    label: 'Level 2',
    color: $Color.from('#ff0033'),
  },
  [GradeLevel.Level3]: {
    value: GradeLevel.Level3,
    symbol: '3',
    slug: 'level-3',
    label: 'Level 3',
    color: $Color.from('#33bbff'),
  },
  [GradeLevel.Level4]: {
    value: GradeLevel.Level4,
    symbol: '4',
    slug: 'level-4',
    label: 'Level 4',
    color: $Color.from('#4887ff'),
  },
  [GradeLevel.Level5]: {
    value: GradeLevel.Level5,
    symbol: '5',
    slug: 'level-5',
    label: 'Level 5',
    color: $Color.from('#ffbb00'),
  },
  [GradeLevel.Level6]: {
    value: GradeLevel.Level6,
    symbol: '6',
    slug: 'level-6',
    label: 'Level 6',
    color: $Color.from('#ff6633'),
  },
  [GradeLevel.Level7]: {
    value: GradeLevel.Level7,
    symbol: '7',
    slug: 'level-7',
    label: 'Level 7',
    color: $Color.from('#66cc33'),
  },
  [GradeLevel.Level8]: {
    value: GradeLevel.Level8,
    symbol: '8',
    slug: 'level-8',
    label: 'Level 8',
    color: $Color.from('#22bb99'),
  },
} as const);
